import React, { useReducer, useEffect, useRef } from "react";
import {
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Grid,
  IconButton,
  FormLabel,
  Button,
  Input,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import authService from "services/authService";
import { updateProfileFormReducer } from "reducers/formReducers";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PropTypes from "prop-types";
import subtract from "assets/images/Subtract.svg";
import penIcon from "assets/images/penIcon.svg";
import tagAdminConstants from "constants/tagAdminConstants";

const initialState = {
  showPassword: false,
  showCPassword: false,
  passwordMissmatch: false,
  username: "",
  password: "",
  phone: "",
  errors: { phone: "", title: "", password: "", firstname: "", lastname: "" },
  firstname: "",
  lastname: "",
  confirmPasswrd: "",
  title: "",
  photoUpload: null,
};

function CreateAccountForm({ loadingStatusFunc }) {
  /*
    Getting ID from url
  */

  const location = useLocation();
  const hiddenFileInput = useRef(null);
  const navigate = useNavigate();
  const [formState, dispatch] = useReducer(
    updateProfileFormReducer,
    initialState
  );
  const onChange = (e) => {
    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
    dispatch({ type: "validation", errors: initialState.errors });
  };
  useEffect(() => {
    const path = location.search;
    if (path.trim().length !== 0) {
      const pathArray = path.split("id=");
      const UId = pathArray["1"];

      authService.getProfileData(UId).then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "setInitialData",
            payload: res.data,
          });
        }
      });
    }
  }, []);
  const {
    showPassword = true,
    showCPassword = true,
    username,
    password,
    phone,
    errors,
    firstname,
    lastname,
    confirmPasswrd,
    title,
    photoUpload,
    user,
  } = formState;
  const toggleShow = (toggleField) => {
    dispatch({
      type: toggleField,
      payload: {
        field: toggleField,
        value: toggleField === "showPassword" ? !showPassword : !showCPassword,
      },
    });
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const imageValidation = (imagetype) => {
    let validImageType = false;
    const imagetypeValid = imagetype.name.match(
      tagAdminConstants.UPLOAD_IMAGE_PATTERN_REGEX
    );
    if (!imagetypeValid) {
      validImageType = true;
    }
    return validImageType;
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];

    const checkValidImage = imageValidation(fileUploaded);
    if (checkValidImage) {
      const issues = {};
      issues.organizationImage = "*Please select valid image.";
      dispatch({
        type: "validation",
        payload: {
          issues,
        },
      });
      return;
    }
    dispatch({
      type: "photoUpload",
      payload: {
        fileUploaded,
      },
    });
    const reader = new FileReader();
    reader.onload = () => {
      const dataURL = reader.result;
      const output = document.getElementById("photoUpload");
      output.src = dataURL;
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  const validateForm = () => {
    let formIsValid = true;
    const issues = {};
    if (!phone) {
      formIsValid = false;
      issues.phone = "*Please enter your Phone.";
    }
    if (!password) {
      formIsValid = false;
      issues.password = "*Please enter your password.";
    } else if (typeof password !== "undefined") {
      if (password.length <= 7) {
        formIsValid = false;
        issues.password = "*Your password must be 8 charcters longs or more.";
      }
    }
    if (!confirmPasswrd) {
      formIsValid = false;
      issues.confirmPassword = "*Please enter your confirm password.";
    }

    if (password && confirmPasswrd && password !== confirmPasswrd) {
      issues.passwordMissmatch = "(Your Passwords Do Not Match)";
    }

    if (!firstname) {
      formIsValid = false;
      issues.firstname = "*Please enter your first name.";
    }

    if (!lastname) {
      formIsValid = false;
      issues.lastname = "*Please enter your last name.";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const updateUser = (event) => {
    event.preventDefault();
    loadingStatusFunc(true);
    const validationResults = validateForm();
    if (validationResults) {
      authService
        .updateProfile(
          password,
          phone,
          firstname,
          lastname,
          title,
          photoUpload,
          user
        )
        .then((response) => {
          loadingStatusFunc(false);
          if (response) {
            navigate("/accountCreated");
          }
        });
    }
    loadingStatusFunc(false);
  };
  return (
    <div className="b-loginform-container">
      <form onSubmit={updateUser}>
        <CardContent className="b-loginform-container__card">
          <h3 className="b-loginform-container__account-text">
            Lets get started
          </h3>
          <Typography>
            <span className="font-bold b-loginform-container__label-text-first">
              Primary Email
            </span>
            <span className="b-account-form-container__span-text">
              (Please contact TAG if this needs to be updated.)
            </span>
          </Typography>
          <div id="underlinehide">
            <TextField
              className="b-account-form-container__textField"
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      className="b-account-form-container__img"
                      src={subtract}
                      alt=""
                    />
                  </InputAdornment>
                ),
              }}
              name="username"
              value={username}
              variant="standard"
              size="small"
              disabled
            />
          </div>

          <div>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <div className="b-account-form-container__uploader">
                  {photoUpload == null ? (
                    <>
                      <button
                        className="dafault-font-family b-account-form-container__button"
                        type="button"
                        onClick={(event) => handleClick(event)}
                      >
                        Add Photo
                      </button>
                      <Input
                        className="b-account-form-container__input"
                        type="file"
                        ref={hiddenFileInput}
                        name
                        onChange={handleChange}
                        accept="image/*"
                      />
                      <span className="b-account-form-container__span">
                        <img
                          className="b-account-form-container__uploaderImg"
                          src={penIcon}
                          alt="Error in loading"
                        />
                      </span>
                      <div className="b-account-form-container__errorMsg errorMsg">
                        {photoUpload}
                      </div>
                    </>
                  ) : (
                    <>
                      <Button
                        onClick={(event) => handleClick(event)}
                        type="button"
                      >
                        <img
                          className="b-account-form-container__uploader-file"
                          id="photoUpload"
                          alt=""
                          src={`${photoUpload}`}
                        />
                        <Input
                          className="b-account-form-container__inputFile"
                          type="file"
                          ref={hiddenFileInput}
                          onChange={handleChange}
                        />
                      </Button>
                      {errors && errors?.issues !== "" && (
                        <div className="b-loginform-container__errorMsg errorMsg">
                          {errors?.issues?.photoUpload}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Grid>
              <Grid item md={8} id="underlinehide">
                <Typography className="font-bold b-account-form-container__name-typography">
                  <FormLabel
                    htmlFor="firstname"
                    className="b-loginform-container__label-filed"
                  >
                    First Name
                  </FormLabel>
                </Typography>
                <TextField
                  className="b-account-form-container__nameField"
                  id="firstname"
                  name="firstname"
                  variant="standard"
                  value={firstname}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  onChange={onChange}
                  size="large"
                />
                {errors && errors?.issues !== "" && (
                  <div className="b-loginform-container__errorMsg errorMsg">
                    {errors?.issues?.firstname}
                  </div>
                )}
                <Typography className="font-bold  b-account-form-container__name-typography">
                  <FormLabel
                    htmlFor="lastname"
                    className="b-loginform-container__label-filed"
                  >
                    Last Name
                  </FormLabel>
                </Typography>
                <TextField
                  className="b-account-form-container__nameField"
                  id="lastname"
                  name="lastname"
                  variant="standard"
                  value={lastname}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  onChange={onChange}
                  size="small"
                />
                {errors && errors?.issues !== "" && (
                  <div className="b-loginform-container__errorMsg errorMsg">
                    {errors?.issues?.lastname}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
          <div id="underlinehide">
            <Typography className="font-bold b-account-form-container__name-typography">
              <FormLabel
                htmlFor="phone"
                className="b-loginform-container__label-filed"
              >
                Phone
              </FormLabel>
            </Typography>
            <TextField
              className="b-account-form-container__nameField-full"
              id="phone"
              name="phone"
              value={phone}
              variant="standard"
              InputProps={{
                disableUnderline: true,
              }}
              onChange={onChange}
              size="small"
              type="text"
            />
          </div>
          {errors && errors?.issues !== "" && (
            <div className="b-loginform-container__errorMsg errorMsg">
              {errors?.issues?.phone}
            </div>
          )}
          <div id="underlinehide">
            <Typography className="font-bold b-account-form-container__typographyTitle">
              <FormLabel
                htmlFor="title"
                className="b-loginform-container__label-filed"
              >
                Title
              </FormLabel>
            </Typography>
            <TextField
              className="b-account-form-container__nameField-full"
              id="title"
              name="title"
              value={title}
              variant="standard"
              InputProps={{
                disableUnderline: true,
              }}
              onChange={onChange}
              size="small"
            />
          </div>
          {errors && errors?.issues !== "" && (
            <div className="b-loginform-container__errorMsg errorMsg">
              {errors?.issues?.title}
            </div>
          )}
        </CardContent>
        <CardContent className="remove b-account-form-container__cardSection">
          <div id="underlinehide">
            <FormLabel
              htmlFor="password"
              className="font-bold b-account-form-container__cardContent"
            >
              Password
            </FormLabel>
            <TextField
              className="font-bold b-account-form-container__passwordField"
              variant="standard"
              name="password"
              type={showPassword ? "password" : "text"}
              id="password"
              onChange={onChange}
              value={password}
              size="small"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        toggleShow("showPassword");
                      }}
                    >
                      {showPassword === false ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors && errors?.issues !== "" && (
              <div className="b-loginform-container__errorMsgg errorMsg">
                {errors?.issues?.password}
              </div>
            )}
          </div>
          {/* <div className="errorMsg2">{state.errors.password}</div> */}
          <div
            id="underlinehide"
            className="b-account-form-container__padding_top"
          >
            <FormLabel
              htmlFor="cpassword"
              className="font-bold  b-account-form-container__confirmPassword"
            >
              Confirm Password
            </FormLabel>
            <TextField
              className="b-account-form-container__passwordField"
              name="confirmPasswrd"
              id="cpassword"
              variant="standard"
              size="small"
              type={showCPassword ? "password" : "text"}
              value={confirmPasswrd}
              onChange={onChange}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        toggleShow("showCPassword");
                      }}
                    >
                      {showCPassword === false ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {errors && errors.passwordMissmatch !== "" && (
            <div id="c2password underlinehide">
              <span className="dafault-font-family b-account-form-container__passwordText">
                {errors.passwordMissmatch}
              </span>
            </div>
          )}
        </CardContent>
        <div className="b-loginform-container__loginhead">
          <Button
            variant="outlined"
            type="submit"
            className=" b-loginform-container__loginbtn"
          >
            <span className="form-button-text"> Create Account </span>
          </Button>
        </div>
      </form>
    </div>
  );
}

CreateAccountForm.propTypes = {
  loadingStatusFunc: PropTypes.func.isRequired,
};

export default CreateAccountForm;
